/* shadcn/ui — vendored MIT source. Upstream: ui.shadcn.com (components/ui/skeleton).
   Unmodified apart from the import path for cn(). */
import { cn } from '../lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />;
}

export { Skeleton };
